import { cn } from "@/lib/utils";

export function ScoreRing({
  score,
  size = 64,
  stroke = 6,
  label,
}: {
  score: number;
  size?: number;
  stroke?: number;
  label?: string;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const dash = (pct / 100) * c;
  const color =
    pct >= 75
      ? "text-success"
      : pct >= 50
        ? "text-primary"
        : pct >= 30
          ? "text-warning"
          : "text-destructive";

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          strokeWidth={stroke}
          className="stroke-muted fill-transparent"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          strokeWidth={stroke}
          strokeLinecap="round"
          className={cn("fill-transparent transition-all", color)}
          stroke="currentColor"
          strokeDasharray={`${dash} ${c - dash}`}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className={cn("font-mono font-semibold tabular-nums leading-none", color)}
          style={{ fontSize: size * 0.28 }}
        >
          {Math.round(pct)}
        </span>
        {label && (
          <span className="text-[9px] uppercase tracking-wider text-muted-foreground mt-0.5">
            {label}
          </span>
        )}
      </div>
    </div>
  );
}
